import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";

export const generateOtp = createAsyncThunk("create/otp", async (payload) => {
  const req = `${BASE_URL}/workflow/generateOtp`;

  let params = {
    body: payload
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);

  const options = {
    method: "POST",
    body: JSON.stringify(encryptedBodyRes),
    headers: {
      "Content-Type": "application/json",
    },
  };
  const _options = {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const result = await encryptPayload(req, options, false, true,true);
    // const result = await encryptPayload(req, _options, false, false);

    // console.log({ result });
    return result.data
  } catch (err) {
    // console.log(err);
  }
});

export const resendOtp = createAsyncThunk("resend/otp", async (payload) => {
  const req = `${BASE_URL}/workflow/resendOTP`;

  let data = {
    token_id: payload.token_id,
    regenerate: true, // used to generate unique otp each time
    otp_mode:payload.otp_mode,
    organisation_id:payload?.organisation_id?payload?.organisation_id:"",
    contactInfo:payload?.contact_info?payload?.contact_info:"",
    retiresLeft:payload?.retiresLeft?payload?.retiresLeft:0,
    application_ref_id: payload?.application_ref_id,
    maximum_retry : payload?.maximum_retry,
    blocking_duration : payload?.blocking_duration,
  };
  let params = {
    body: data
  }
  const encryptedBodyRes = await encryptPayload('', params, true, true);
  const options = {
    method: "POST",
    body: JSON.stringify(encryptedBodyRes),
    headers: {
      "Content-Type": "application/json",
    },
  };
  const _options = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    // const result = await encryptPayload(req, options, false, true);
    const result = await encryptPayload(req, _options, false, false,true);
    // console.log("resend otp",result);
    return result
  } catch (err) {
    // console.log(err);
  }
});

export const verifyOtp = createAsyncThunk("verify/otp", async (payload) => {
  const req = `${BASE_URL}/workflow/validateOTP`;
  const options = {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const result = await apiRequest(req, options,true);
    return result
  } catch (err) {
    // console.log(err);
  }
});

//not used 
// export const verifyOtpWithPhone = createAsyncThunk("verify/Mobileotp", async (payload) => {
//   const req = `${BASE_URL}/workflow/validateOTP`;
//   const options = {
//     method: "POST",
//     body: JSON.stringify(payload),
//     headers: {
//       "Content-Type": "application/json",
//     },
//   };

//   try {
//     const result = await apiRequest(req, options,true);
//     return result
//   } catch (err) {
//     // console.log(err);
//   }
// });
